import { render } from "./ErrorNoAccess.vue?vue&type=template&id=393bd181&scoped=true&ts=true"
import script from "./ErrorNoAccess.vue?vue&type=script&lang=ts"
export * from "./ErrorNoAccess.vue?vue&type=script&lang=ts"

import "./ErrorNoAccess.vue?vue&type=style&index=0&id=393bd181&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-393bd181"]])

export default __exports__